import { Factbox as e } from "./components/Factbox.es.js";
import { FactboxTitle as t } from "./components/FactboxTitle.es.js";
import "./components/index.es.js";
import { consumes as n } from "./lib/consumes.es.js";
import { consume as r } from "./lib/consume.es.js";
import { FactboxBody as i } from "./components/FactboxBody.es.js";
import { actionHandler as a } from "./lib/actionHandler.es.js";
import { normalizeFactbox as o } from "./lib/normalizeFactbox.es.js";
import { BoxIcon as s } from "lucide-react";
import { jsx as c } from "react/jsx-runtime";
import { Editor as l, Element as u, Transforms as d } from "slate";
//#region lib/Factbox/index.tsx
var f = (f) => ({
	class: "block",
	name: "core/factbox",
	options: f,
	consumer: {
		consumes: n,
		consume: f?.consume ?? r
	},
	actions: [{
		name: "core/factbox",
		title: f?.addSingleLabel ?? "Insert factbox",
		tool: () => /* @__PURE__ */ c(s, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: a,
		visibility: () => [
			!0,
			!0,
			!1
		]
	}, {
		name: "edit-factbox",
		handler: ({ editor: e, args: t }) => {
			let n = Array.from(l.nodes(e, {
				at: [],
				mode: "highest",
				match: (e) => !l.isEditor(e) && u.isElement(e) ? e.id === t?.id : !1
			})), [, r] = n?.length === 1 ? n[0] : [void 0, void 0];
			d.setNodes(e, { properties: {
				editable: t?.editable || !1,
				id: t?.id,
				original_updated: t?.original_updated,
				original_version: t?.original_version,
				locally_changed: t?.locally_changed,
				original_id: t?.original_id
			} }, { at: r });
		}
	}],
	componentEntry: {
		class: "block",
		component: e,
		constraints: { normalizeNode: o },
		children: [{
			type: "title",
			class: "text",
			component: t,
			constraints: { allowBreak: !1 }
		}, {
			type: "body",
			class: "block",
			component: i
		}]
	}
});
//#endregion
export { f as Factbox };
